import React from 'react'
import { Button } from 'react-bootstrap'

interface PaginationProps {
    page: number
    setPage: (page: number) => void
    total: number
    limit: number
    onPageChange: (page: number) => void
}

const Pagination: React.FC<PaginationProps> = ({ page, setPage, total, limit, onPageChange }: PaginationProps) => {
    const totalPages = Math.ceil(total / limit)
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1)

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            {pages.map(p => (
                <Button
                    className={'btn btn-bold' + (p === page ? ' btn-primary active' : '')}
                    key={p}
                    onClick={() => {
                        setPage(p)
                        onPageChange(p)
                    }}
                >
                    {p}
                </Button>
            ))}
        </div>
    )
}

export default Pagination
